<template>
  <div>
    <el-dialog
      title="Introducer Update"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : '40%'"
      :before-close="handleClose"
      top="5vh" 
      
    >
      <el-form
          :model="introducerForm"
          ref="introducerForm"
          label-width="150px"
          size="small"
          :label-position="device === 'mobile' ? 'top' : 'right'"
         
        >
        <el-form-item>
          <el-tag type="danger">Update introducer status may reset the downline</el-tag>         
        </el-form-item>
          <el-form-item label="Status">
            <el-select v-model="introducerForm.status">
              <el-option label="ON" value="ON"></el-option>
              <el-option label="OFF" value="OFF"></el-option>
            </el-select>
          </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submiting" @click="updateIntroducer()"
          >Submit</el-button
        >
        <el-button @click="handleClose">Cancel</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import { updateIntroducer } from '@/api/introducer'
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    }
  },
  data() {
    return {
      dialogShow: false,
      submiting: false,
      enduser_id: "",
      introducerForm: {
        "status": ""
      }
    
    }
  },
  methods:{
    openDialog(enduser_id, introducer_status){
      this.dialogShow = true;
      this.enduser_id = enduser_id
      this.introducerForm.status = introducer_status
    },

    updateIntroducer(){
      this.submiting = true
      updateIntroducer(this.enduser_id, this.introducerForm).then(({result}) =>{
        this.submiting = false
        if(result){
          this.$notify({
            title: "Success",
            message: `Update introducer successfully`,
            type: "success",
            duration: 2000
          });
          this.handleClose()
          this.$emit("submited", true);
        }
      })
    },


    handleClose() {
      this.dialogShow = false;
    },
  }
}
</script>

<style lang="scss">
.member-info{
  p{
    line-height: 20px;
  }
}
</style>